<template>
  <div style="padding-right:5px;margin-bottom:50px;">
    <div>
      <button
        :disabled="loading"
        v-if="
          this.saveOKQuestions &&
            !this.saveOKAnswers.includes(false) &&
            !this.$store.state.sondage.fields.results_count &&
            this.saveSectionOK
        "
        @click="saveForm"
        v-bind:class="{
          'is-loading is-danger': this.$store.state.question.isSaving,
          'is-primary': !this.$store.state.question.isSaving
        }"
        class="button is-primary"
      >
        {{ $t("button.sauvegarder") }}
      </button>
    </div>
    <div style="width:100%">
      <b-message
        style="font-size:12px;"
        type="is-danger"
        v-if="this.$store.state.sondage.fields.results_count"
        >{{ $t("button.sauvegarder_impossible") }}</b-message
      >
      <b-message
        style="font-size:12px;"
        type="is-danger"
        v-if="this.saveOKAnswers.includes(false) || !this.saveOKQuestions"
        >{{ $t("sondage.sauvegarderhasOneAnswer") }}</b-message
      >
      <b-message
        style="font-size:12px;"
        type="is-danger"
        v-if="!this.saveSectionOK"
        >{{ $t("sondage.sauvegarderhasOneQuestionInSection") }}</b-message
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      saveOKAnswers: [],
      saveSectionOK: true,
      saveOKQuestions: false,
      loading: false
    }
  },
  watch: {
    testSaveQuestionButton () {
      this.saveSectionOK = true
      this.hasOneAnswer()
    },
    testSaveAnswersButton () {
      this.saveSectionOK = true
      this.hasOneAnswer()
    },
    testSaveSectionsButton () {
      this.saveSectionOK = true
      this.hasOneAnswer()
    },
    questions () {
      this.saveSectionOK = true
      this.hasOneAnswer()
      if (this.loading === true) {
        this.$router.push({ name: 'Admin' })
      }
    }
  },
  created () {
    this.hasOneAnswer()
  },
  computed: {
    ...mapGetters([
      'testSaveQuestionButton',
      'testSaveAnswersButton',
      'testSaveSectionsButton',
      'questions'
    ])
  },
  methods: {
    hasOneAnswer () {
      if (this.$store.state.question.sections.length) {
        this.$store.state.question.sections.forEach(section => {
          if (!section.questions.length) {
            this.saveSectionOK = false
          }
          this.conditionQuestions(section.questions)
          this.conditionPropositions(section.questions)
        })
      } else if (this.$store.state.question.questions.length) {
        this.conditionQuestions(this.$store.state.question.questions)
        this.conditionPropositions(this.$store.state.question.questions)
      }
    },
    conditionPropositions (questions) {
      this.saveOKAnswers = []
      questions.forEach(question => {
        if (question.answers) {
          if (
            question.element_type !== 'notation' &&
            question.element_type !== 'content'
          ) {
            if (question.answers.length < 2) {
              this.saveOKAnswers.push(false)
            } else if (question.answers !== []) {
              question.answers.forEach((answer, index) => {
                if (answer.proposition_type !== 'content') {
                  // condition answers translations (fr, en , es, de) => button save is disabled
                  if (this.$store.getters.sondage_languages.includes('fr')) {
                    if (
                      answer.entitled === null ||
                      answer.entitled === '' ||
                      answer.entitled === undefined
                    ) {
                      this.saveOKAnswers.push(false)
                    } else {
                      this.saveOKAnswers.push(true)
                    }
                  }
                  if (this.$store.getters.sondage_languages.includes('en')) {
                    if (
                      answer.entitled_en === null ||
                      answer.entitled_en === '' ||
                      answer.entitled_en === undefined
                    ) {
                      this.saveOKAnswers.push(false)
                    } else {
                      this.saveOKAnswers.push(true)
                    }
                  }
                  if (this.$store.getters.sondage_languages.includes('es')) {
                    if (
                      answer.entitled_es === null ||
                      answer.entitled_es === '' ||
                      answer.entitled_es === undefined
                    ) {
                      this.saveOKAnswers.push(false)
                    } else {
                      this.saveOKAnswers.push(true)
                    }
                  }
                  if (this.$store.getters.sondage_languages.includes('de')) {
                    if (
                      answer.entitled_de === null ||
                      answer.entitled_de === '' ||
                      answer.entitled_de === undefined
                    ) {
                      this.saveOKAnswers.push(false)
                    } else {
                      this.saveOKAnswers.push(true)
                    }
                  }
                }
              })
            }
          }
        }
      })
    },
    conditionQuestions (questions) {
      this.saveOKQuestions = true
      questions.forEach(question => {
        // condition question translations (fr, en , es, de) => button save is disabled
        /* if (this.$store.getters.sondage_languages.length > 1) { */
        if (this.$store.getters.sondage_languages.includes('fr')) {
          if (question.entitled === null || question.entitled === '') {
            this.saveOKQuestions = false
          }
        }
        if (this.$store.getters.sondage_languages.includes('en')) {
          if (question.entitled_en === null || question.entitled_en === '') {
            this.saveOKQuestions = false
          }
        }
        if (this.$store.getters.sondage_languages.includes('es')) {
          if (question.entitled_es === null || question.entitled_es === '') {
            this.saveOKQuestions = false
          }
        }
        if (this.$store.getters.sondage_languages.includes('de')) {
          if (question.entitled_de === null || question.entitled_de === '') {
            this.saveOKQuestions = false
          }
        }
        /* } else {
          // if only one translation
          if (question.entitled === null || question.entitled === '') {
            this.saveOKQuestions = false
          } */
      })
    },
    saveForm (evt) {
      this.loading = true
      this.$store.dispatch('saveQuestions')
    }
  }
}
</script>

<style scoped>
.button {
  border-radius: 4px;
  color: white;
  font-size: 12px;
}
.button-danger {
  border-radius: 4px;
  font-size: 12px;
  width: 100px;
  padding: 15px;
  width: 100%;
  background-color: red;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/SaveQuestionButton.vue